import type { IPhoto, IPhotoApi } from 'src/interfaces';

export const mapApiToPhoto = ({ thumb_url, ...rest }: IPhotoApi): IPhoto => ({
  ...rest,
  thumbUrl: thumb_url,
});

export const mapApiToPhotos = (photos: IPhotoApi[]): IPhoto[] => photos.map(mapApiToPhoto);
